// extracted by mini-css-extract-plugin
module.exports = {"page_container":"styles_page_container__2pM1a","cards_container":"styles_cards_container__2VVE5","grid_container":"styles_grid_container__FZBkb"};